export default [
  {
    path: '/main/frota/helpers',
    meta: {
      tag: 'list_frota_helpers',
      name: 'Ajudantes',
      breadcrumb: 'Ajudantes'
    },
    component: () => import(/* webpackChunkName: "frota-helpers-list" */ '@/views/main/settings/frota/helper/Index.vue'),
    children: [
      {
        path: '',
        name: 'listfrotahelper',
        meta: {
          tag: 'list_frota_helpers',
          menu: 'settings',
          name: 'Ajudantes'
        },
        component: () => import(/* webpackChunkName: "frota-helpers-list" */ '@/views/main/settings/frota/helper/List.vue'),
      }
    ]
  }
]
